// Authentication page for Studio1 Alpha
// WorkOS OAuth authentication via backend

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { LoginButton } from "../components/auth/LoginButton";
// Sign Up hidden during closed beta — registration is gated by the email
// allowlist (power#860). Restore when public sign-up opens.
// import { SignUpButton } from "../components/auth/SignUpButton";

export const AuthPage: React.FC = () => {
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Check for error in URL parameters
    const urlParams = new URLSearchParams(location.search);
    const errorParam = urlParams.get("error");
    if (errorParam) {
      setError(decodeURIComponent(errorParam));
    }
  }, [location.search]);

  return (
    <div className="min-h-screen flex flex-col justify-center relative overflow-hidden">
      <div className="sm:mx-auto sm:w-full sm:max-w-md relative z-10">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <img
              src="/logo512.png"
              alt="Studio1"
              className="w-32 invert dark:invert-0"
            />
          </div>
          <p className="">Professional workflow automation platform</p>
        </div>
      </div>

      <div className="sm:mx-auto sm:w-full sm:max-w-md relative z-10">
        <div className="bg-white/95 backdrop-blur-sm py-8 px-6 shadow-lg rounded-lg border border-white/20">
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Welcome</h2>
            <p className="text-gray-600 mt-2">
              Sign in to access your workspace
            </p>
          </div>

          {error && (
            <div className="mb-6 bg-red-50 border border-red-200 rounded-md p-4">
              <p className="text-red-800 text-sm">{error}</p>
            </div>
          )}

          <LoginButton />

          {/* Sign Up hidden during closed beta — registration is gated by the
              email allowlist (power#860). Restore when public sign-up opens. */}
          {/* <SignUpButton className="mt-3" /> */}

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-500">
              Secure authentication powered by WorkOS
            </p>
          </div>
        </div>
      </div>

      <div className="mt-8 text-center relative z-10">
        <p className="text-xs text-gray-500">
          By signing in, you agree to our{" "}
          <a href="#" className="text-blue-600 hover:text-blue-500">
            Terms of Service
          </a>{" "}
          and{" "}
          <a href="#" className="text-blue-600 hover:text-blue-500">
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};
